import React, { useState, useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'


import DEIPageClusterChart from '../DEIPageClusterChart/DEIPageClusterChart'
import DEIPageClusterChartLegend from '../DEIPageClusterChartLegend/DEIPageClusterChartLegend'

import { DEI_COLORS } from "../constants"

import {
  DEIPageFullTeamGenderChartDIV,
  DEIPageFullTeamGenderLegendDIV,
  DEIPageFullTeamGenderGridDIV,
  DEIPageFullTeamGenderSECTION,
} from './DEIPageFullTeamGender.styles'

const DEIPageFullTeamGender = ({ gender }) => {
  const [activeDate, setactiveDate] = useState(gender.dates[0])
  const [activeType, setactiveType] = useState(null)
  const types = useMemo(() => activeDate.percentages.map(type => type), [activeDate])
  const colors = [
    DEI_COLORS.BLUE,
    DEI_COLORS.PURPLE,
    DEI_COLORS.INDIGO,
    DEI_COLORS.NEUTRAL,
  ]

  return (
    <DEIPageFullTeamGenderSECTION>
      <div className="container">
        <DEIPageFullTeamGenderGridDIV>
          <div className="column column--1-7-M">
            <DEIPageFullTeamGenderChartDIV>
              <DEIPageClusterChart
                activeType={activeType}
                colors={colors}
                percentages={activeDate.percentages}
              />
            </DEIPageFullTeamGenderChartDIV>
          </div>
          <div className="column column--8-13-M column--8-12-L">
            <DEIPageFullTeamGenderLegendDIV>
              <DEIPageClusterChartLegend
                activeDateTitle={activeDate.title}
                colors={colors}
                dates={gender.dates}
                onHoverType={type => setactiveType(type)}
                onSelectDate={date => setactiveDate(date)}
                title="Full team by gender"
                types={types}
              />
            </DEIPageFullTeamGenderLegendDIV>
          </div>
        </DEIPageFullTeamGenderGridDIV>
      </div >
    </DEIPageFullTeamGenderSECTION >
  )
}

export default DEIPageFullTeamGender
